import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11.5 20h-6.5a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v3","key":"svg-0"}],["path",{"d":"M9 13a3 3 0 1 0 6 0a3 3 0 0 0 -6 0","key":"svg-1"}],["path",{"d":"M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5","key":"svg-2"}]]

const IconCameraSpark = createReactComponent('outline', 'camera-spark', 'CameraSpark', __iconNode);

export default IconCameraSpark;